import { Flex, Box, Image } from "@chakra-ui/react";
import getImageSrc from "src/utils/getImageSrc";
import { Lottie } from "src/components/Lottie";

export default function DogAvatar({
  imageName,
  width = "100%",
  height = "100%",
  withSleepingAnimation = true,
  browserProps
}) {
  const isSleepingAnimation =
    imageName.includes("sleeping") && withSleepingAnimation;
  return (
    <Flex
      justifyContent="center"
      alignItems="center"
      width={width}
      position="relative"
      height={height}
    >
      {isSleepingAnimation && (
        <Box position="absolute" top="0" bottom="0" right="0" left="0">
          <Lottie
            width="100%"
            height="100%"
            animationName="zzz.json"
            browserProps={{ useTheme: false }}
          />
        </Box>
      )}
      <Image
        width="100%"
        src={getImageSrc(imageName, { directory: "dogs" }, browserProps)}
      />
    </Flex>
  );
}
